import { OnInit, Input, Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
    selector: 'app-participacao-empresa-n1-pj',
    templateUrl: './participacao-empresa-n1-pj.component.html',
    styleUrls: ['./../cadastral-pj/cadastral-pj.component.css']
})

export class ParticipacaoEmpresaN1PjComponent implements OnInit {

    @Input() dados:any;

    public txtButtonConsultar:string='Consultar agora';
    public consultando:Boolean=false;
    public naoSolicitou:Boolean=false;
    public naoEncontrouRegistros:Boolean=false;
    public modalRef:BsModalRef;

    constructor(private modalService:BsModalService) {}

    ngOnInit(): void {

        if(this.dados.participacao_empresa_n1 === undefined){
            this.naoSolicitou = true;
        } else if(this.dados.participacao_empresa_n1 === null) {
            this.naoEncontrouRegistros = true;
        }
    }
}